<template lang="html">
  <ck-viewer></ck-viewer>
</template>

<script>
import ckViewer from '@/components/media/browser'

export default {
	components: {
		ckViewer
	},
	data: function() {
		return {
			paramName: 'CKEditorFuncNum'
		}
	},
  created: function () {
    this.$store.commit('hideSidebar')
  },
	mounted: function() {
		let funcNum = this.$route.query.CKEditorFuncNum
		this.$parent.$on('image', file => {
			let fileUrl = file.images.big[0]
			this.loadImage(funcNum, fileUrl)
		})
	},
	methods: {
		loadImage: function(funcNum, fileUrl) {
			// eslint-disable-next-line
			window.opener.CKEDITOR.tools.callFunction(funcNum, fileUrl)
			window.close()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/media/ckeditor.browser.vue